<script>
import { DATE_RANGE_OPTIONS } from '../../constants';

const EVENT_NAME = 'on-range-change';

export default {
  name: 'ReportFiltersDateRange',
  data() {
    return {
      selectedId: Object.values(DATE_RANGE_OPTIONS)[0].id,
    };
  },
  computed: {
    // computed, so the labels follow the user locale that App.vue sets after mount
    options() {
      return Object.values(DATE_RANGE_OPTIONS).map(option => ({
        ...option,
        name: this.$t(option.translationKey),
      }));
    },
    selectedOption: {
      get() {
        return this.options.find(option => option.id === this.selectedId);
      },
      set(option) {
        this.selectedId = option.id;
      },
    },
  },
  methods: {
    updateRange(selectedRange) {
      this.selectedOption = selectedRange;
      this.$emit(EVENT_NAME, selectedRange);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      track-by="id"
      label="name"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :options="options"
      :searchable="false"
      :allow-empty="false"
      @select="updateRange"
    />
  </div>
</template>
